import http from "./httpService";
import config from "./../config.json";

let apiEndpoint = process.env.REACT_APP_API_URL || config.apiUrl;
apiEndpoint += "price-components";

export const getAvailablePriceComponentsAsync = async (id, params) => {
  const {
    sort_column,
    search_query: query,
    current_page: page,
    page_size: size,
  } = params;

  const { path: column, order } = sort_column;
  const url = `${apiEndpoint}/available/${id}?q=${query}&column=${column}&order=${order}&p=${page}&s=${size}`;

  const { data } = await http.get(url);
  return data;
};

export const priceComponentService = {
  getAvailablePriceComponentsAsync,
};

export default priceComponentService;
